var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLightTask(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 20.4141C11.0667 20.4141 10.1875 20.2682 9.3625 19.9766C8.5375 19.6849 7.78333 19.2724 7.1 18.7391L5.7 20.1141C5.51667 20.2974 5.28333 20.3891 5 20.3891C4.71667 20.3891 4.48333 20.2974 4.3 20.1141C4.11667 19.9307 4.025 19.6974 4.025 19.4141C4.025 19.1307 4.11667 18.8974 4.3 18.7141L5.675 17.3391C5.14167 16.6557 4.72917 15.8974 4.4375 15.0641C4.14583 14.2307 4 13.3474 4 12.4141C4 10.1807 4.775 8.28906 6.325 6.73906C7.875 5.18906 9.76667 4.41406 12 4.41406H20V12.4141C20 14.6474 19.225 16.5391 17.675 18.0891C16.125 19.6391 14.2333 20.4141 12 20.4141ZM12 18.4141C13.6667 18.4141 15.0833 17.8307 16.25 16.6641C17.4167 15.4974 18 14.0807 18 12.4141V6.41406H12C10.3333 6.41406 8.91667 6.9974 7.75 8.16406C6.58333 9.33073 6 10.7474 6 12.4141C6 13.0641 6.1 13.6849 6.3 14.2766C6.5 14.8682 6.775 15.4057 7.125 15.8891L12.3 10.7141C12.4833 10.5307 12.7167 10.4391 13 10.4391C13.2833 10.4391 13.5167 10.5307 13.7 10.7141C13.9 10.9141 14 11.1516 14 11.4266C14 11.7016 13.9 11.9391 13.7 12.1391L8.525 17.3141C9.00833 17.6641 9.54583 17.9349 10.1375 18.1266C10.7292 18.3182 11.35 18.4141 12 18.4141Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightTask);
export default __webpack_public_path__ + "static/media/light_task.4c9e03203ca7505f940f9fe8dd716be7.svg";
export { ForwardRef as ReactComponent };